var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"100px"}},[_c('div',{staticClass:"ui divider"}),_vm._v(" "),_c('abstractTable',{attrs:{"columns":_vm.readingsColumns,"data":_vm.medicalMachineReadings,"classes":'ui celled very compact center aligned table',"keyIsDate":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b15f472c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/medical_machines/medical_machine_components/details_components/Readings.vue
// module id = null
// module chunks = 